import { h } from "vue";
import { VBtn, VIcon } from "vuetify/components";
import { DialogLayout } from "vue-app-components";
import MarkdownWrapper from "../markdown/markdown-wrapper.vue";

const markdownFiles = import.meta.glob("../markdown/**/*.md", { eager: true });

function titleFromFilename (name) {
  return name
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

const mdRegistry = [];

for (const key in markdownFiles) {
  if (key.match(/README\.md$/) || key.match(/markdown-wrapper\.vue/)) {
    continue;
  }

  const mdId = key.replace(/^\.\.\/markdown\//, "").replace(/\.md$/, "");
  const mdName = key.match(/^.*\/(.*).md$/)[1];
  const mdComponent = markdownFiles[key].default;

  mdRegistry.push({
    mdId,
    mdName,
    mdComponent,
    title: titleFromFilename(mdName),
    dialogComponentName: `dialog-${mdId}`
  });
}

export default function registerMarkdownComponents (app) {
  for (const entry of mdRegistry) {
    app.component(entry.dialogComponentName, {
      components: {
        VBtn,
        VIcon
      },
      props: {
        navIcon: {
          type: String,
          required: true
        },
        fullscreen: {
          type: Boolean,
          required: true
        },
        dark: {
          type: Boolean,
          default: false
        }
      },
      render: function () {
        const self = this;

        return h(
          DialogLayout,
          {
            title: entry.title,
            fullscreen: self.fullscreen,
            navIcon: self.navIcon,
            dark: self.dark !== false,
            onPopDialog: function () {
              self.$emit("pop-dialog");
            },
            emits: ["pop-dialog"]
          },
          {
            default: () => {
              return h(MarkdownWrapper, { name: entry.mdName }, {
                default: () => {
                  return h(
                    entry.mdComponent,
                    {
                      onLinkedClicked: function (name) {
                        self.$emit("push-dialog", name);
                      },
                      emits: ["push-dialog"]
                    }
                  );
                }
              });
            }
          }
        );
      }
    });
  }
}
